import styled, { useTheme } from 'styled-components';

import { flexStart } from '../../style/reusableStyle';
import Avatar from '../Avatar';
import Tag from '../Tag';
import Typography from '../Typography';

const ScheduleTagStyled = styled.div<{
  $status: StatusType;
  $bgColor?: string;
  $textColor?: string;
}>`
  flex-shrink: 0;
  max-width: fit-content;
  & .avatar-text-wrapper {
    ${flexStart};
    gap: 8px;
    padding: 5px 16px 5px 5px;
    background: ${({ theme, $bgColor }) =>
      $bgColor || theme.colors.darkViolet.faded};
    color: ${({ theme, $textColor }) =>
      $textColor || theme.colors.darkViolet.strong};
    border-radius: 21px;
    margin-bottom: 8px;

    & .avatar {
    }
    & .text {
    }
  }
  & .status-wrapper {
  }
`;

type StatusType = 'Pending' | 'Active' | 'Completed';

type Props = {
  avatar: string;
  status?: StatusType;
  title: string;
  textColor?: string;
  bgColor?: string;
  className?: string;
};

const ScheduleTag = ({
  avatar,
  bgColor,
  status = 'Pending',
  textColor,
  title,
  className,
}: Props) => {
  const theme = useTheme();
  const statusToColorMap = {
    Pending: {
      color: theme.colors.red.strong,
      background: theme.colors.red.faded,
    },
    Active: {
      color: theme.colors.blue.strong,
      background: theme.colors.blue.faded,
    },
    Completed: {
      color: theme.colors.green.strong,
      background: theme.colors.green.faded,
    },
  };

  return (
    <ScheduleTagStyled
      $status={status}
      $bgColor={bgColor}
      $textColor={textColor}
      className={className}
    >
      <div className="avatar-text-wrapper">
        <Avatar size={'sm'} src={avatar} />
        <Typography style={{ color: 'inherit' }}>{title}</Typography>
      </div>
      <div className="status-wrapper">
        <Tag
          style={{
            padding: '3px 10px',
            fontSize: '12px',
            ...statusToColorMap[status],
          }}
        >
          {status}
        </Tag>
      </div>
    </ScheduleTagStyled>
  );
};

export default ScheduleTag;
